import { render, staticRenderFns } from "./HeaderEndorsementTable.vue?vue&type=template&id=5116a23d"
import script from "./HeaderEndorsementTable.vue?vue&type=script&lang=js"
export * from "./HeaderEndorsementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports